import axios from "axios";
import authHeader from "./auth-token-header";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = false;
axios.defaults.timeout = 10000;

let showModalCallback = () => {};

axios.interceptors.request.use(
    function (config) {
        if (config.url !== "/login" && config.url !== "/register") {
            const headers = authHeader();
            config.headers = { ...config.headers, ...headers };
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    function (response) {
        return response.data ? response.data : response;
    },
    function (error) {
        let message;
        switch (error.status) {
            case 401:
                message = "Your login might have expired. Please login again.";
                showModalCallback(message);
                sessionStorage.removeItem("authTokenData");
                break;
            case 403:
                message = "Your don't have permissions to access this data. Contact your administrator.";
                showModalCallback(message);
                break;
            default:
                message = error.message || error;
        }
        return Promise.reject(error);
    }
);


class ApiClient {
    constructor() {
        this.baseURL = "/api";
    }

    // Function to construct the complete URL
    createURL = (endpoint) => {
        return `${this.baseURL}/${endpoint}`;
    };

    get = (endpoint, params) => {
        return axios.get(this.createURL(endpoint), { params });
    };

    post = (endpoint, data) => {
        return axios.post(this.createURL(endpoint), data);
    };

    put = (endpoint, data) => {
        return axios.put(this.createURL(endpoint), data);
    };

    patch = (endpoint, data) => {
        return axios.patch(this.createURL(endpoint), data);
    };

    delete = (endpoint, config) => {
        return axios.delete(this.createURL(endpoint), { ...config });
    };
}

const getLoggedinUser = () => {
    const user = sessionStorage.getItem("authTokenData");
    return user ? JSON.parse(user) : null;
};

export const setModalCallback = (callback) => {
    showModalCallback = callback;
};

export { ApiClient, getLoggedinUser };
